import FeedbackChart from "./FeedbackChart";

export default FeedbackChart;